import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from 'react';
import translations, { LANGUAGES } from '../i18n/translations';

const I18nContext = createContext({ lang: 'en', setLang: () => {}, t: (k) => k, langs: LANGUAGES });

const STORAGE_KEY = 'wss_lang';

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === 'undefined') return 'en';
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && translations[saved]) return saved;
    const browser = (navigator.language || 'en').slice(0, 2);
    return translations[browser] ? browser : 'en';
  });

  const setLang = useCallback((code) => {
    if (!translations[code]) return;
    localStorage.setItem(STORAGE_KEY, code);
    setLangState(code);
  }, []);

  const t = useCallback((key) => {
    return (translations[lang] && translations[lang][key]) || translations.en[key] || key;
  }, [lang]);

  useEffect(() => {
    if (typeof document !== 'undefined') document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t, langs: LANGUAGES }), [lang, setLang, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useT = () => useContext(I18nContext);
export default I18nContext;
